import { render, staticRenderFns } from "./OrderInstallments.vue?vue&type=template&id=0f1f81d6&"
import script from "./OrderInstallments.vue?vue&type=script&lang=js&"
export * from "./OrderInstallments.vue?vue&type=script&lang=js&"
import style0 from "./OrderInstallments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports